export default ({ request }) => ({
    mrpOtherStockInListApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/in/list',
        method: 'post',
        data,
      })
    },
    mrpOtherStockInSaveApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/in/save',
        method: 'post',
        data,
      })
    },
    mrpOtherStockInAuditApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/in/audit',
        method: 'post',
        data,
      })
    },
    mrpOtherStockInDetailApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/in/detail',
        method: 'post',
        data,
      })
    },
    mrpOtherStockInDelApi(data = {}) {
      return request({
        url: '/factory/mrp/other/stock/in/del',
        method: 'post',
        data,
      })
    },
  })
  